import setUtilizationModule from './setUtilizationModule';
import setUtilizationUsers from './setUtilizationUsers';

export default {
  setUtilizationModule,
  setUtilizationUsers,
};
